export const ScrollChevron = ({ direction }: { direction: "left" | "right" }) => (
  <svg
    width="10"
    height="14"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={direction === "left" ? "rotate-180" : ""}
    aria-hidden="true"
  >
    <path
      d="M0.294983 10.5949L4.87498 6.00488L0.294982 1.41488L1.70498 0.00488275L7.70498 6.00488L1.70498 12.0049L0.294983 10.5949Z"
      fill="currentColor"
    />
  </svg>
)
